<template>
  <div class="modal fade" tabindex="-1" id="loadingSignatureModal" ref="modal" aria-labelledby="loadingSignatureModalLabel"
       aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h1 v-if="statusSigned" class="modal-title fs-5 text-center">
            Sucesso!
          </h1>
          <h1 class="modal-title fs-5 text-center" v-else>
            Aguarde enquanto geramos o laudo...
          </h1>
        </div>
        <div class="modal-body">
          <div v-if="statusSigned">
            <p>
              Seu laudo foi assinado com sucesso! Se desejar baixar
              novamente, basta acessar o caso no histórico.
            </p>

          </div>
          <div v-else>
            <div class="text-center">
              <div v-for="(step, index) in steps" :key="index" class="step">
                <div class="status">
                  <template v-if="step.status === 1">
                    <p class="text-font-ok">✔</p>
                  </template>
                  <template v-if="step.status === 2">
                    <img alt="avatar1" src="../assets/error-loading-signature.png"/>
                  </template>
                  <template v-if="step.status === 0">
                    <div class="loading_modal" style="margin-top: 5px;"></div>
                  </template>
                </div>
                <div class="text" style="margin-top: 5px;">{{ step.text }}</div>
              </div>
            </div>
            <div v-if="showRetryButton">
              <p class="modal-text text-font-regular">Caso o problema persista, acione o suporte.</p>
            </div>
            <div v-if="showDownloadButton">
              <p class="modal-text text-font-regular">Caso o problema persista, faça o
                <a class="link-button" @click="downloadReportModal">download aqui</a> do laudo sem assinatura.
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button v-if="showRetryButton" class="btn btn-primary" @click="retryTentativeGenerate">
            Tentar novamente
          </button>
          <button v-if="showDownloadButton || showRetryButton || statusSigned" class="btn btn-secondary" @click="backProtocols" data-bs-dismiss="modal" >
            Início
          </button>
          <button v-if="statusSigned" class="btn btn-outline-success" @click="downloadReportModal">
            Baixar relatório
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";
import { Modal } from "bootstrap";

export default {
  props: {
    typeSteps: String,
    visibleModalLoadingSignature: Boolean,
  },
  computed: {
    ...mapGetters({
      Report: "StateReport",
      User: "StateUser",
      UrlReport: "StateUrlReport"
    }),
  },
  data() {
    return {
      steps: [
        {text: "Salvar arquivo.", status: 0}, //0 - loading, 1 - success, 2 - error
        {text: "Assinatura iniciada.", status: 0},
        {text: "Assinatura finalizada.", status: 0},
        {text: "Arquivo assinado salvo.", status: 0},
      ],
      stopVerify: false,
      statusSigned: false,
      showDownloadButton: false,
      showRetryButton: false,
    };
  },
  beforeUnmount() {
    window.Echo.leaveChannel('file_status.' + this.Report.id);
  },
  async mounted() {
    await this.GetReport(this.Report);
    window.Echo.channel('file_status.' + this.Report.id).listen("FileStatusUpdated", function () {
      this.validSteps();
    }.bind(this));
  },
  methods: {
    ...mapActions(["GetEnable"]),
    ...mapActions(["GetReport"]),
    ...mapActions(["UpdateReport"]),
    ...mapActions(["GenerateReport"]),
    ...mapActions(["ResignReport"]),
    ...mapActions(["GenerateUrlReport"]),
    backProtocols() {
      this.$router.push('/protocols');
    },
    async validSteps() {
      await this.GetReport(this.Report);
      if (this.typeSteps === "historic") {
        this.processLoadingHistoric();
      }
      if (this.typeSteps === "review") {
        this.processLoadingReview();
      }
    },

    async downloadReportModal() {
      try {
        await this.GenerateReport(this.Report)
        const pdfUrl = this.UrlReport;
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },

    async processLoadingHistoric() {
      if (this.Report.finished === 1 && this.stopVerify === false) {
        this.showRetryButton = false;
        this.steps[0].status = 1;
        var assinaturaIniciada = this.Report.statuses.find(function (elemento) {
          return elemento.step === 2;
        });
        if (assinaturaIniciada) {
          if (assinaturaIniciada.status === "success") {
            this.steps[1].status = 1;
            var assinaturaFinalizada = this.Report.statuses.find(function (elemento) {
              return elemento.step === 3;
            });
            if (assinaturaFinalizada) {
              if (assinaturaFinalizada.status === "success") {
                this.steps[2].status = 1;
                var arquivoAssinado = this.Report.statuses.find(function (elemento) {
                  return elemento.step === 4;
                });
                if (arquivoAssinado) {
                  if (arquivoAssinado.status === "success") {
                    this.steps[3].status = 1;
                    this.showDownloadButton = false,
                        this.showRetryButton = false
                    this.statusSigned = true
                  }
                  if (arquivoAssinado.status === "error") {
                    this.steps[3].text = arquivoAssinado.description;
                    this.steps[3].status = 2;
                    this.stopVerify = true
                    this.showDownloadButton = true
                  }
                }
              }
              if (assinaturaFinalizada.status === "error") {
                this.steps[2].text = assinaturaFinalizada.description;
                this.steps[2].status = 2;
                this.steps[3].status = null;
                this.stopVerify = true
                this.showDownloadButton = true
              }
            }
          }
          if (assinaturaIniciada.status === "error") {
            this.steps[1].text = assinaturaIniciada.description;
            this.steps[1].status = 2;
            this.steps[2].status = null;
            this.steps[3].status = null;
            this.stopVerify = true
            this.showDownloadButton = true;
          }
        }
      }
    },

    async processLoadingReview() {
      if (this.Report.finished === 1 && this.stopVerify === false) {
        if (this.Report.statuses.length === 0) {
          this.steps[0].status = 2;
          this.steps[1].status = null;
          this.steps[2].status = null;
          this.steps[3].status = null;
          this.stopVerify = true;
          this.showRetryButton = true;
        } else {
          var arquivoSalvo = this.Report.statuses.find(function (elemento) {
            return elemento.step === 1;
          });
          if (arquivoSalvo) {
            if (arquivoSalvo.status === "success") {
              this.showRetryButton = false;
              this.steps[0].status = 1;
              let assinaturaIniciada = this.Report.statuses.find(function (elemento) {
                return elemento.step === 2;
              });
              if (assinaturaIniciada) {
                if (assinaturaIniciada.status === "success") {
                  this.steps[1].status = 1;
                  let assinaturaFinalizada = this.Report.statuses.find(function (elemento) {
                    return elemento.step === 3;
                  });
                  if (assinaturaFinalizada) {
                    if (assinaturaFinalizada.status == "success") {
                      this.steps[2].status = 1;
                      let arquivoAssinado = this.Report.statuses.find(function (elemento) {
                        return elemento.step === 4;
                      });
                      if (arquivoAssinado) {
                        if (arquivoAssinado.status == "success") {
                          this.steps[3].status = 1
                          this.showDownloadButton = false
                          this.showRetryButton = false
                          this.statusSigned = true
                        }
                        if (arquivoAssinado.status === "error") {
                          this.steps[3].text = arquivoAssinado.description;
                          this.steps[3].status = 2;
                          this.stopVerify = true
                          this.showDownloadButton = true
                        }
                      }
                    }
                    if (assinaturaFinalizada.status === "error") {
                      this.steps[2].text = assinaturaFinalizada.description;
                      this.steps[2].status = 2;
                      this.steps[3].status = null;
                      this.stopVerify = true
                      this.showDownloadButton = true
                    }
                  }
                }
                if (assinaturaIniciada.status === "error") {
                  this.steps[1].text = assinaturaIniciada.description;
                  this.steps[1].status = 2;
                  this.steps[2].status = null;
                  this.steps[3].status = null;
                  this.stopVerify = true
                  this.showDownloadButton = true;
                }
              }
            }
            if (arquivoSalvo.status === "error") {
              this.steps[0].status = 2;
              this.steps[1].status = null;
              this.steps[2].status = null;
              this.steps[3].status = null;
              this.stopVerify = true
              this.showRetryButton = true;
            }
          }
        }
      }
    },

    resetFlow() {
      this.stopVerify = false
      this.statusSigned = false
      this.showDownloadButton = false
      this.showRetryButton = false
      this.steps[0].status = 0;
      this.steps[0].text = "Salvar arquivo.";
      this.steps[1].status = 0;
      this.steps[1].text = "Assinatura iniciada.";
      this.steps[2].status = 0;
      this.steps[2].text = "Assinatura finalizada.";
      this.steps[3].status = 0;
      this.steps[3].text = "Arquivo assinado salvo.";
    },

    retryTentativeResign() {
      this.resetFlow()
      this.ResignReport(this.Report)
      this.validSteps();
    },

    retryTentativeGenerate() {
      this.resetFlow()
      this.GenerateUrlReport(this.Report)
      this.validSteps();
    },

    show() {
      const modal = new Modal(this.$refs.modal, {})
      modal.show()
    }
  },
  expose: ['show']
}

</script>

<style>
.step {
  display: flex;
}

.status {
  margin-right: 10px;
  font-size: 24px;
}

.loading_modal {
  width: 24px;
  height: 24px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-top: 4px solid #3498db;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

.link-button {
  color: #6200ee;
  /* Cor inicial do texto */
  text-decoration: none;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: 400;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

.text-font-ok {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  color: green;
}

.text-font-regular {
  font-family: "Roboto", sans-serif;
  font-weight: 100;
  color: #777777;
}

</style>
